"use client";

import { ArrowUpRight, FileText, Scale, Shield } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheNylaAdvantage() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const pillars = [{
    reference: "§ 01 / INFRASTRUCTURE",
    title: "Construction Management & Consulting",
    description: "We deliver robust physical infrastructure with precision engineering, expert guidance and project oversight to ensure projects are planned, executed, completed efficiently, safely, and within budget. Our team ensures every build meets the highest standards of durability and safety.",
    subServices: ["GENERAL CONTRACTING", "Structural Engineering", "Site Development"],
    Icon: FileText
  }, {
    reference: "§ 02 / DIGITAL CORE",
    title: "Technology Solutions",
    description: "Powering your business with integrated software and hardware ecosystems. We design custom digital frameworks that streamline operations and enhance connectivity across your entire organization.",
    subServices: ["Software Development", "WEB HOSTING", "Hardware Deployment"],
    Icon: Shield
  }, {
    reference: "§ 03 / STRATEGY",
    title: "Operational Excellence",
    description: "Optimizing your business performance through data-driven strategy. We bridge the gap between physical assets and digital intelligence to drive sustainable growth and efficiency.",
    subServices: ["Process Optimization", "Project Management", "PAYMENT PROCESSING"],
    Icon: Scale
  }];
  return <section data-section-id="2803" id="the-nyla-advantage" className="bg-background text-foreground py-24 md:py-36 px-6 md:px-12 overflow-hidden light">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center mb-20 md:mb-28 transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm tracking-[0.3em] uppercase text-muted-foreground mb-8">
            § 05 — THE NYLA ADVANTAGE
          </p>
          <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl mx-auto">
            Three pillars
            <br />
            of{" "}
            <em className="font-default italic font-normal" style={{
            color: "var(--primary)"
          }}>
              excellence
            </em>
            .
          </h2>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 relative transition-all duration-1000 delay-200 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {pillars.map((pillar, i) => {
          const Icon = pillar.Icon;
          return <div data-index={i} key={pillar.reference} className={`group relative px-6 md:px-10 py-12 md:py-8 transition-all duration-500 ${i > 0 ? "md:border-l border-t md:border-t-0 border-border group-hover:border-primary" : ""}`}>
                {}
                <div className="hidden md:block absolute top-0 bottom-0 left-0 w-px opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
              background: "linear-gradient(to bottom, transparent 0%, var(--primary) 50%, transparent 100%)",
              boxShadow: "0 0 12px var(--primary)"
            }} aria-hidden="true" />
                <div className="hidden md:block absolute top-0 bottom-0 right-0 w-px opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
              background: "linear-gradient(to bottom, transparent 0%, var(--primary) 50%, transparent 100%)",
              boxShadow: "0 0 12px var(--primary)"
            }} aria-hidden="true" />

                {}
                <div className="mb-10 flex items-start">
                  <Icon className="w-24 h-24 transition-colors duration-500" strokeWidth={1.25} style={{
                color: "var(--primary)"
              }} aria-hidden="true" />
                </div>

                {}
                <p className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground mb-5">
                  {pillar.reference}
                </p>

                {}
                <h3 className="font-default font-bold text-2xl md:text-3xl leading-tight mb-6 text-foreground">
                  {pillar.title}
                </h3>

                {}
                <p className="font-default text-sm md:text-[15px] leading-relaxed text-muted-foreground mb-8">
                  {pillar.description}
                </p>

                {}
                <ul className="space-y-3 mb-10">
                  {pillar.subServices.map((service, j) => <li data-index={j} key={service} className="flex items-center gap-3 font-mono text-[11px] tracking-[0.18em] uppercase text-foreground/80">
                      <span className="w-1 h-1 rounded-lg shrink-0" style={{
                  backgroundColor: "var(--primary)"
                }} aria-hidden="true" />
                      <span>{service}</span>
                    </li>)}
                </ul>

                {}
                <Link to="/HomePage" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase text-foreground/70 hover:text-foreground transition-colors duration-300 group/link">
                  <span className="relative">
                    EXPLORE MORE
                    <span className="absolute left-0 -bottom-1 h-px w-8 group-hover/link:w-full transition-all duration-500 ease-out" style={{
                  backgroundColor: "var(--primary)"
                }} aria-hidden="true" />
                  </span>
                  <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" strokeWidth={1.5} />
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}